import { render, staticRenderFns } from "./share_link.vue?vue&type=template&id=5b6718cc&scoped=true&"
import script from "./share_link.vue?vue&type=script&lang=js&"
export * from "./share_link.vue?vue&type=script&lang=js&"
import style0 from "./share_link.vue?vue&type=style&index=0&id=5b6718cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6718cc",
  null
  
)

export default component.exports